module.exports = __webpack_public_path__ + "img/qrcode_3.7ff38b8.png";